<template>
  <div id="app">  
    <Menu />
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  components: {
    Menu,
    Footer
  },
  data () {
    return {
      
    }
  }
}
</script>

<style>
:root {
  --prim-c:#2c3e50;
  --sec-c:#fff;
  --acc-c:#42b983;
  --p-font:'Rubik', Helvetica, Arial, sans-serif;
  --h-font:;
}

* {
  margin:0;
  padding:0;
  box-sizing: border-box;
  transition: .2s;
}

a {
  text-decoration: none;
  font-weight: 400;
}

html,body {
  position: relative;
  display: block;
  height:100%;
  width:100%;
  -webkit-tap-highlight-color:transparent;
  -webkit-user-select: none; /* Chrome/Safari */        
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  text-rendering: geometricPrecision;
  font-size: 14px;
  font-feature-settings: "liga"1;
  -webkit-font-feature-settings: "liga"1;
  -moz-font-feature-settings: "liga"1;
}

#app {
  font-family:var(--p-font);
  font-weight:400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--prim-c);
  padding:0;
}

main {
  min-height:80vh;
  padding:10px 10px 50px 10px;
}

/* Headers */

h1 {
    font-family: var(--h-font);
    font-weight: 400;
    font-size: 52px;
}

h2 {
    font-family: var(--h-font);
    font-weight: 600;
    font-size: 48px;
}

h3 {
    font-family: var(--h-font);
    font-weight: 400;
    font-size: 42px;
}

h4 {
    font-family: var(--h-font);
    font-weight: 400;
    font-size: 38px;
}

h5 {
    font-family: var(--h-font);
    font-weight: 800;
    font-size: 32px;
}

h6 {
    font-family: var(--h-font);
    font-weight: 600;
    font-size: 22px;
}

h1,
h2,
h3 {
    margin: 0 0 1rem 0;
}

h4,
h5,
h6 {
    margin: 0.5rem 0;
}

/* Paragraphs, spans and other text */

p,
a,
span {
    font-family: var(--p-font);
    margin: 0 0 0.5rem 0;
}

p {
    max-width: 600px;
    line-break: normal;
    word-break: normal;
    line-height: 1.5;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {}

/* Links */

a {
    text-decoration: none;
    color: var(--a-c);
    /* cursor: url(../img/cursor.png), auto; */
}

.hidden {
    position: absolute;
    overflow: hidden;
    width: 0;
    height: 0;
    pointer-events: none;
}

.link-wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

/* Lists */

ol,
ul,
li {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

/* Buttons */

.def-btn a {
    padding: 8px 20px;
    color: var(--sec-c);
    background: var(--prim-c);
    text-align: center;
}

/*** Quick Classes ***/

/* Hide */

.hide {
    display: none !important;
}

/* Opacity */

.op-0 {
    opacity: 0;
}

.op-05 {
    opacity: 0.5;
}

.op-1 {
    opacity: 1;
}

/* Overflow */

.over-h {
    overflow: hidden;
}

.over-a {
    overflow: auto;
}

.over-s {
    overflow: scroll;
}

.over-xh {
    overflow-x: hidden;
}

/* Height */

.vh-full {
    height: 100vh;
}

.vh-half {
    height: 50vh;
}

.h-full {
    height: 100%;
}

.h-half {
    height: 50%;
}

.h-1000 {
    height: 1000px;
}

.h-850 {
    height: 850px;
}

.h-600 {
    height: 600px;
}

.h-300 {
    height: 300px;
}

/* Width */

.w-full {
    width: 100%;
}

.vw-full {
    width: 100vw;
}

.vw-half {
    width: 50vw;
}

/* Flex options */

.d-flex-r {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.d-flex-c {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.d-flex-center {
    justify-content: center;
    align-items: center;
}

.d-flex-start {
    justify-content: flex-start;
}

.d-flex-end {
    justify-content: end;
}

/* Flex width */

/* Desktop width */
.d-flex-w1 {
    width: 100%;
}

.d-flex-w2 {
    width: 50%;
}

.d-flex-w3 {
    width: 33.333%;
}

.d-flex-w4 {
    width: 25%;
}

.d-flex-w5 {
    width: 20%;
}

.d-flex-w6 {
    width: 16.666%;
}

/* Tablet Width  */
@media (max-width:2000px) {

    .td-flex-w1 {
        width: 100%;
    }

    .td-flex-w2 {
        width: 50%;
    }

    .td-flex-w3 {
        width: 33.333%;
    }

    .td-flex-w4 {
        width: 25%;
    }

    .td-flex-w5 {
        width: 20%;
    }

    .td-flex-w6 {
        width: 16.666%;
    }
}

/* Mobile Width  */
@media (max-width:768px) {
    .md-flex-w1 {
        width: 100%;
    }

    .md-flex-w2 {
        width: 50%;
    }

    .md-flex-w3 {
        width: 33.333%;
    }

    .md-flex-w4 {
        width: 25%;
    }

    .md-flex-w5 {
        width: 20%;
    }

    .md-flex-w6 {
        width: 16.666%;
    }
}

/* Max Width */

.mw-100 {
    max-width: 100%;
}

.mw-90 {
    max-width: 90%;
}

.mw-80 {
    max-width: 80%;
}

.mw-70 {
    max-width: 70%;
}

.mw-60 {
    max-width: 60%;
}

.mw-50 {
    max-width: 50%;
}

.mw-40 {
    max-width: 40%;
}

.mw-30 {
    max-width: 30%;
}

.mw-20 {
    max-width: 20%;
}

.mw-10 {
    max-width: 10%;
}

/* Mobile Max width */

@media (max-width:768px) {
    /* Max Width */

    .m-mw-100 {
        max-width: 100%;
    }

    .m-mw-90 {
        max-width: 90%;
    }

    .m-mw-80 {
        max-width: 80%;
    }

    .m-mw-70 {
        max-width: 70%;
    }

    .m-mw-60 {
        max-width: 60%;
    }

    .m-mw-50 {
        max-width: 50%;
    }

    .m-mw-40 {
        max-width: 40%;
    }

    .m-mw-30 {
        max-width: 30%;
    }

    .m-mw-20 {
        max-width: 20%;
    }

    .m-mw-10 {
        max-width: 10%;
    }
}

/* Justify and Align */

.ji-c {
    justify-items: center;
}

.ji-s {
    justify-items: flex-start;
}

.ji-e {
    justify-items: flex-end;
}

.jc-c {
    justify-content: center;
}

.jc-s {
    justify-content: flex-start;
}

.jc-e {
    justify-content: flex-end;
}

.align-c {
    align-items: center;
}

/* Position */

.p-r {
    position: relative;
}

.p-a {
    position: absolute;
}

.p-f {
    position: fixed;
}

.p-s {
    position: sticky;
}

.p-top {
    top: 0;
}

.p-btm {
    bottom: 0;
}

.p-left {
    left: 0;
}

.p-right {
    right: 0;
}

/* padding */

.pad-top-s {
    padding-top:var(--pad-s);
}
.pad-btm-s {
    padding-bottom:var(--pad-s);
}
.pad-left-s {
    padding-left:var(--pad-s);
}
.pad-right-s {
    padding-right:var(--pad-s);
}

.pad-top-m {
    padding-top:var(--pad-m);
}
.pad-btm-m {
    padding-bottom:var(--pad-m);
}
.pad-left-m {
    padding-left:var(--pad-m);
}
.pad-right-m {
    padding-right:var(--pad-m);
}

.pad-top-l {
    padding-top:var(--pad-l);
}
.pad-btm-l {
    padding-bottom:var(--pad-l);
}
.pad-left-l {
    padding-left:var(--pad-l);
}
.pad-right-l {
    padding-right:var(--pad-l);
}

.pad-top-xl {
    padding-top:var(--pad-xl);
}
.pad-btm-xl {
    padding-bottom:var(--pad-xl);
}
.pad-left-xl {
    padding-left:var(--pad-xl);
}
.pad-right-xl {
    padding-right:var(--pad-xl);
}

/* opacity */

.o-0 {
    opacity: 0;
}

.o-3 {
    opacity: 0.3;
}

.o-5 {
    opacity: 0.5;
}

.o-7 {
    opacity: 0.7
}

.o-1 {
    opacity: 1;
}

/* z-index */

.z-0 {
    z-index: -1;
}

.z-1 {
    z-index: 1;
}

.z-2 {
    z-index: 2;
}

.z-3 {
    z-index: 3;
}

.z-4 {
    z-index: 4;
}

.z-5 {
    z-index: 5;
}

.z-6 {
    z-index: 6;
}

.z-7 {
    z-index: 7;
}

.z-8 {
    z-index: 8;
}

.z-9 {
    z-index: 9;
}

/* Animation */

.a-both {
    animation-fill-mode: both !important;
}

.a-forwards {
    animation-fill-mode: forwards !important;
}

.a-backwards {
    animation-fill-mode: backwards !important;
}

.a-d-025 {
    animation-delay: 0.25s !important;
}

.a-d-05 {
    animation-delay: 0.5s !important;
}

.a-d-075 {
    animation-delay: 0.75s !important;
}

.a-d-1 {
    animation-delay: 1s !important;
}

.a-d-2 {
    animation-delay: 2s !important;
}

.a-d-3 {
    animation-delay: 3s !important;
}

.reveal-in-b,
.reveal-in-t,
.reveal-in-t-show,
.reveal-in-l,
.reveal-in-r {
    opacity: 0;
}

body.loaded .reveal-in-b,
body.loaded .reveal-in-t,
body.loaded .reveal-in-t-show,
body.loaded .reveal-in-l,
body.loaded .reveal-in-r {
    opacity: 1;
}

body.loaded .reveal-in-b {
    animation: revealInBottom .5s both ease;
    -webkit-animation: revealInBottom .5s both ease;
}

body.loaded .reveal-in-t {
    animation: revealInTop .5s both ease;
    -webkit-animation: revealInTop .5s both ease;
}

body.loaded .reveal-in-t-show {
    animation: revealInTopShow .5s both ease;
    -webkit-animation: revealInTopShow .5s both ease;
}


body.loaded .reveal-in-r {
    animation: revealInRight .5s both ease;
    -webkit-animation: revealInRight .5s both ease;
}

body.loaded .reveal-in-l {
    animation: revealInLeft .5s both ease;
    -webkit-animation: revealInLeft .5s both ease;
}

/* Images */

.img-fit {
    object-fit: cover;
}


/* Media Breakpoints */

@media (max-width:1500px) {}

@media (max-width:1200px) {
    /* Headers */

    h1 {
        font-family: var(--h-font);
        font-weight: 400;
        font-size: 48px;
    }

    h2 {
        font-family: var(--h-font);
        font-weight: 600;
        font-size: 42px;
    }

    h3 {
        font-family: var(--h-font);
        font-weight: 400;
        font-size: 32px;
    }

    h4 {
        font-family: var(--h-font);
        font-weight: 400;
        font-size: 28px;
    }

    h5 {
        font-family: var(--h-font);
        font-weight: 800;
        font-size: 22px;
    }

    h6 {
        font-family: var(--h-font);
        font-weight: 600;
        font-size: 18px;
    }
}

@media (max-width:768px) {

    /* Headers */

    h1 {
        font-family: var(--h-font);
        font-weight: 400;
        font-size: 38px;
    }

    h2 {
        font-family: var(--h-font);
        font-weight: 600;
        font-size: 32px;
    }

    h3 {
        font-family: var(--h-font);
        font-weight: 400;
        font-size: 28px;
    }

    h4 {
        font-family: var(--h-font);
        font-weight: 400;
        font-size: 22px;
    }

    h5 {
        font-family: var(--h-font);
        font-weight: 800;
        font-size: 18px;
    }

    h6 {
        font-family: var(--h-font);
        font-weight: 600;
        font-size: 16px;
    }

    .m-reveal-in-b,
    .m-reveal-in-t,
    .m-reveal-in-l,
    .m-reveal-in-r {
        opacity: 0;
    }

    body.loaded .m-reveal-in-b,
    body.loaded .m-reveal-in-t,
    body.loaded .m-reveal-in-l,
    body.loaded .m-reveal-in-r {
        opacity: 1;
    }

    body.loaded .m-reveal-in-b {
        animation: revealInBottom .5s both ease;
        -webkit-animation: revealInBottom .5s both ease;
    }

    body.loaded .m-reveal-in-t {
        animation: revealInTop .5s both ease;
        -webkit-animation: revealInTop .5s both ease;
    }

    body.loaded .m-reveal-in-r {
        animation: revealInRight .5s both ease;
        -webkit-animation: revealInRight .5s both ease;
    }

    body.loaded .m-reveal-in-l {
        animation: revealInLeft .5s both ease;
        -webkit-animation: revealInLeft .5s both ease;
    }

}

</style>
